class CollectionGridPagination {
  static init(options = {}) {
    const grid = document.querySelector('[data-ajax-collection-grid]');
    if (!grid) return;

    const pageSizeDesktop = Number(grid.dataset.pageSizeDesktop) || 9;
    const pageSizeMobile = Number(grid.dataset.pageSizeMobile) || 6;
    const pageSize = window.matchMedia('(max-width: 749px)').matches ? pageSizeMobile : pageSizeDesktop;
    const items = [...grid.querySelectorAll('.badass-collection-grid__item')].filter(
      (item) => !item.classList.contains('is-filter-hidden')
    );
    const total = items.length;
    const totalPages = Math.max(1, Math.ceil(total / pageSize));

    let page = Number(options.page);
    if (!Number.isFinite(page) || page < 1) {
      const urlPage = Number(new URLSearchParams(window.location.search).get('gp'));
      page = Number.isFinite(urlPage) && urlPage > 0 ? urlPage : 1;
    }
    if (page > totalPages) page = totalPages;

    const start = (page - 1) * pageSize;
    const end = start + pageSize;
    items.forEach((item, index) => {
      item.classList.toggle('is-page-hidden', index < start || index >= end);
    });

    CollectionGridPagination.renderControls(page, totalPages, options.updateURL !== false, options.push === true);
    CollectionGridPagination.bindClicks();
  }

  static renderControls(page, totalPages, updateURL, push) {
    const wrapper = document.querySelector('[data-collection-pagination]');
    if (!wrapper) return;

    if (totalPages <= 1) {
      wrapper.innerHTML = '';
      wrapper.hidden = true;
      CollectionGridPagination.syncUrlPage(1, updateURL, push);
      return;
    }

    wrapper.hidden = false;
    const caret = CollectionGridPagination.caretSvg();
    let html = '<nav class="pagination" role="navigation" aria-label="Pagination"><ul class="pagination__list list-unstyled" role="list">';

    if (page > 1) {
      html += `<li><a href="?gp=${page - 1}" class="pagination__item pagination__item--next pagination__item-arrow link motion-reduce" data-collection-page="${page - 1}" aria-label="Previous page"><span class="svg-wrapper">${caret}</span></a></li>`;
    }

    for (let pageNum = 1; pageNum <= totalPages; pageNum += 1) {
      if (pageNum === page) {
        html += `<li><a role="link" aria-disabled="true" class="pagination__item pagination__item--current light" aria-current="page" aria-label="Page ${pageNum}">${pageNum}</a></li>`;
      } else {
        html += `<li><a href="?gp=${pageNum}" class="pagination__item link" data-collection-page="${pageNum}" aria-label="Page ${pageNum}">${pageNum}</a></li>`;
      }
    }

    if (page < totalPages) {
      html += `<li><a href="?gp=${page + 1}" class="pagination__item pagination__item--prev pagination__item-arrow link motion-reduce" data-collection-page="${page + 1}" aria-label="Next page"><span class="svg-wrapper">${caret}</span></a></li>`;
    }

    html += '</ul></nav>';
    wrapper.innerHTML = html;
    CollectionGridPagination.syncUrlPage(page, updateURL, push);
  }

  static caretSvg() {
    return '<svg aria-hidden="true" focusable="false" class="icon icon-caret" viewBox="0 0 10 6"><path fill-rule="evenodd" clip-rule="evenodd" d="M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z" fill="currentColor"/></svg>';
  }

  static syncUrlPage(page, updateURL, push = false) {
    if (!updateURL) return;
    const params = new URLSearchParams(window.location.search);
    params.delete('page');
    if (page <= 1) params.delete('gp');
    else params.set('gp', String(page));
    const next = params.toString();
    const url = `${window.location.pathname}${next ? `?${next}` : ''}`;
    const current = `${window.location.pathname}${window.location.search}`;
    if (url !== current) {
      const state = { searchParams: next };
      if (push) history.pushState(state, '', url);
      else history.replaceState(state, '', url);
      FacetFiltersForm.searchParamsPrev = next;
    }
  }

  static bindClicks() {
    if (CollectionGridPagination.bound) return;
    CollectionGridPagination.bound = true;

    document.addEventListener('click', (event) => {
      const link = event.target.closest('[data-collection-page]');
      if (!link) return;
      if (!document.querySelector('[data-ajax-collection-grid]')) return;

      event.preventDefault();
      const page = Number(link.dataset.collectionPage) || 1;
      CollectionGridPagination.init({ page, updateURL: true, push: true });

      const grid = document.getElementById('ProductGridContainer');
      if (grid) {
        const top = grid.getBoundingClientRect().top + window.scrollY - 100;
        window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
      }
    });

    window.matchMedia('(max-width: 749px)').addEventListener('change', () => {
      CollectionGridPagination.init({ updateURL: false });
    });
  }
}

class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 800);

    const facetForm = this.querySelector('form');
    facetForm.addEventListener('input', this.debouncedOnSubmit.bind(this));

    const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
    if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;

      // Client-side collection pagination / pill filters / sort
      const nextParams = new URLSearchParams(searchParams || '');
      const prevParams = new URLSearchParams(FacetFiltersForm.searchParamsPrev || '');
      const nextPage = nextParams.get('gp');
      const nextFilter = nextParams.get('cf') || '';
      const nextSort = nextParams.get('cs') || 'featured';
      ['gp', 'page', 'cf', 'cs'].forEach((key) => {
        nextParams.delete(key);
        prevParams.delete(key);
      });
      if (nextParams.toString() === prevParams.toString() && document.querySelector('[data-ajax-collection-grid]')) {
        FacetFiltersForm.searchParamsPrev = searchParams;
        if (typeof CollectionQuickFilters !== 'undefined' && CollectionQuickFilters.bar) {
          CollectionQuickFilters.sortValue = nextSort;
          if (CollectionQuickFilters.sortSelect) CollectionQuickFilters.sortSelect.value = nextSort;
          CollectionQuickFilters.apply(nextFilter, { updateURL: false, paginate: false });
        }
        CollectionGridPagination.init({
          page: Number(nextPage) || 1,
          updateURL: false,
        });
        return;
      }

      FacetFiltersForm.renderPage(searchParams, null, false);
    };
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static resetGridPage(searchParams) {
    const params = new URLSearchParams(searchParams || '');
    // Filter/sort changes always return to page 1
    params.delete('gp');
    params.delete('page');
    return params.toString();
  }

  static clearSectionCache() {
    FacetFiltersForm.filterData = [];
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const countContainer = document.getElementById('ProductCount');
    const countContainerDesktop = document.getElementById('ProductCountDesktop');
    const loadingSpinners = document.querySelectorAll(
      '.facets-container .loading__spinner, facet-filters-form .loading__spinner'
    );
    loadingSpinners.forEach((spinner) => spinner.classList.remove('hidden'));

    const collectionEl = document.getElementById('ProductGridContainer')?.querySelector('.collection');
    if (collectionEl) collectionEl.classList.add('loading');
    if (countContainer) countContainer.classList.add('loading');
    if (countContainerDesktop) countContainerDesktop.classList.add('loading');

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = (element) => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl)
        ? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event)
        : FacetFiltersForm.renderSectionFromFetch(url, event);
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);
        if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
      })
      .catch(() => {
        const collectionEl = document.getElementById('ProductGridContainer')?.querySelector('.collection');
        if (collectionEl) collectionEl.classList.remove('loading');
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);
    if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
  }

  static renderProductGridContainer(html) {
    const container = document.getElementById('ProductGridContainer');
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const source = doc.getElementById('ProductGridContainer');
    if (!container || !source) return;

    container.innerHTML = source.innerHTML;

    container.querySelectorAll('.scroll-trigger').forEach((element) => {
      element.classList.add('scroll-trigger--cancel');
    });

    CollectionGridPagination.init({ page: 1, updateURL: true, push: false });
  }

  static renderProductCount(html) {
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const countSource = doc.getElementById('ProductCount');
    const container = document.getElementById('ProductCount');
    const containerDesktop = document.getElementById('ProductCountDesktop');

    if (countSource && container) {
      container.innerHTML = countSource.innerHTML;
      container.classList.remove('loading');
    }
    if (countSource && containerDesktop) {
      containerDesktop.innerHTML = countSource.innerHTML;
      containerDesktop.classList.remove('loading');
    }

    const collectionEl = document.getElementById('ProductGridContainer')?.querySelector('.collection');
    if (collectionEl) collectionEl.classList.remove('loading');

    const loadingSpinners = document.querySelectorAll(
      '.facets-container .loading__spinner, facet-filters-form .loading__spinner'
    );
    loadingSpinners.forEach((spinner) => spinner.classList.add('hidden'));
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
    const facetDetailsElementsFromFetch = parsedHTML.querySelectorAll(
      '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter'
    );
    const facetDetailsElementsFromDom = document.querySelectorAll(
      '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter'
    );

    // Remove facets that are no longer returned from the server
    Array.from(facetDetailsElementsFromDom).forEach((currentElement) => {
      if (!Array.from(facetDetailsElementsFromFetch).some(({ id }) => currentElement.id === id)) {
        currentElement.remove();
      }
    });

    const matchesId = (element) => {
      const jsFilter = event ? event.target.closest('.js-filter') : undefined;
      return jsFilter ? element.id === jsFilter.id : false;
    };

    const facetsToRender = Array.from(facetDetailsElementsFromFetch).filter((element) => !matchesId(element));
    const countsToRender = Array.from(facetDetailsElementsFromFetch).find(matchesId);

    facetsToRender.forEach((elementToRender, index) => {
      const currentElement = document.getElementById(elementToRender.id);
      // Element already rendered in the DOM so just update the innerHTML
      if (currentElement) {
        document.getElementById(elementToRender.id).innerHTML = elementToRender.innerHTML;
      } else {
        if (index > 0) {
          const { className: previousElementClassName, id: previousElementId } = facetsToRender[index - 1];
          // Same facet type (eg horizontal/vertical or drawer/mobile)
          if (elementToRender.className === previousElementClassName) {
            document.getElementById(previousElementId).after(elementToRender);
            return;
          }
        }

        if (elementToRender.parentElement) {
          document.querySelector(`#${elementToRender.parentElement.id} .js-filter`).before(elementToRender);
        }
      }
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);

    if (countsToRender) {
      const closestJSFilterID = event.target.closest('.js-filter').id;

      if (closestJSFilterID) {
        FacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));
        FacetFiltersForm.renderMobileCounts(countsToRender, document.getElementById(closestJSFilterID));

        const newFacetDetailsElement = document.getElementById(closestJSFilterID);
        const newElementSelector = newFacetDetailsElement.classList.contains('mobile-facets__details')
          ? `.mobile-facets__close-button`
          : `.facets__summary`;
        const newElementToActivate = newFacetDetailsElement.querySelector(newElementSelector);

        const isTextInput = event.target.getAttribute('type') === 'text';

        if (newElementToActivate && !isTextInput) newElementToActivate.focus();
      }
    }
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      const target = document.querySelector(selector);
      if (target) target.innerHTML = activeFacetsElement.innerHTML;
    });

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = ['.mobile-facets__open', '.mobile-facets__count', '.sorting'];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      const target = document.querySelector(selector);
      if (target) target.innerHTML = html.querySelector(selector).innerHTML;
    });

    const mobileForm = document.getElementById('FacetFiltersFormMobile');
    mobileForm?.closest('menu-drawer')?.bindEvents?.();
  }

  static renderCounts(source, target) {
    const targetSummary = target.querySelector('.facets__summary');
    const sourceSummary = source.querySelector('.facets__summary');

    if (sourceSummary && targetSummary) {
      targetSummary.outerHTML = sourceSummary.outerHTML;
    }

    const targetHeaderElement = target.querySelector('.facets__header');
    const sourceHeaderElement = source.querySelector('.facets__header');

    if (sourceHeaderElement && targetHeaderElement) {
      targetHeaderElement.outerHTML = sourceHeaderElement.outerHTML;
    }

    const targetWrapElement = target.querySelector('.facets-wrap');
    const sourceWrapElement = source.querySelector('.facets-wrap');

    if (sourceWrapElement && targetWrapElement) {
      const isShowingMore = Boolean(target.querySelector('show-more-button .label-show-more.hidden'));
      if (isShowingMore) {
        sourceWrapElement
          .querySelectorAll('.facets__item.hidden')
          .forEach((hiddenItem) => hiddenItem.classList.replace('hidden', 'show-more-item'));
      }

      targetWrapElement.outerHTML = sourceWrapElement.outerHTML;
    }
  }

  static renderMobileCounts(source, target) {
    const targetFacetsList = target.querySelector('.mobile-facets__list');
    const sourceFacetsList = source.querySelector('.mobile-facets__list');

    if (sourceFacetsList && targetFacetsList) {
      targetFacetsList.outerHTML = sourceFacetsList.outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    const grid = document.getElementById('product-grid');
    if (!grid?.dataset?.id) return [];
    return [
      {
        section: grid.dataset.id,
      },
    ];
  }

  createSearchParams(form) {
    const formData = new FormData(form);
    return new URLSearchParams(formData).toString();
  }

  onSubmitForm(searchParams, event) {
    // New filter/sort results always start at grid page 1
    FacetFiltersForm.clearSectionCache();
    FacetFiltersForm.renderPage(FacetFiltersForm.resetGridPage(searchParams), event);
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const sortFilterForms = document.querySelectorAll('facet-filters-form form');
    if (event.srcElement.className == 'mobile-facets__checkbox') {
      const searchParams = this.createSearchParams(event.target.closest('form'));
      this.onSubmitForm(searchParams, event);
    } else {
      const forms = [];
      const isMobile = event.target.closest('form').id === 'FacetFiltersFormMobile';

      sortFilterForms.forEach((form) => {
        if (!isMobile) {
          if (form.id === 'FacetSortForm' || form.id === 'FacetFiltersForm' || form.id === 'FacetSortDrawerForm') {
            forms.push(this.createSearchParams(form));
          }
        } else if (form.id === 'FacetFiltersFormMobile') {
          forms.push(this.createSearchParams(form));
        }
      });
      this.onSubmitForm(forms.join('&'), event);
    }
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url =
      event.currentTarget.href.indexOf('?') == -1
        ? ''
        : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    FacetFiltersForm.clearSectionCache();
    FacetFiltersForm.renderPage(FacetFiltersForm.resetGridPage(url));
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();

class CollectionQuickFilters {
  static init() {
    this.bar = document.querySelector('[data-collection-filters]');
    this.grid = document.querySelector('[data-ajax-collection-grid]');
    this.empty = document.querySelector('[data-filter-empty]');
    if (!this.bar) return;

    this.sortSelect = this.bar.querySelector('[data-collection-sort]');
    this.filterControls = [...this.bar.querySelectorAll('[data-filter-id]')];
    this.dropdowns = [...this.bar.querySelectorAll('[data-filter-dropdown]')];
    this.filterId = '';
    this.sortValue = 'featured';
    this.bound = this.bound || false;

    this.hideEmptyFilters();
    this.bind();

    const params = new URLSearchParams(window.location.search);
    const sortFromUrl = params.get('cs') || 'featured';
    if (this.sortSelect) {
      const validSort = [...this.sortSelect.options].some((option) => option.value === sortFromUrl);
      this.sortSelect.value = validSort ? sortFromUrl : 'featured';
      this.sortValue = this.sortSelect.value;
    }

    let filterFromUrl = params.get('cf') || '';
    const activeControl = this.findControl(filterFromUrl);
    if (!activeControl || activeControl.hidden || activeControl.closest('[hidden]')) {
      filterFromUrl = '';
    }
    this.apply(filterFromUrl, { updateURL: false, paginate: false });
  }

  static hideEmptyFilters() {
    if (!this.grid) return;

    const items = [...this.grid.querySelectorAll('.badass-collection-grid__item')];

    this.filterControls.forEach((control) => {
      const filterId = control.dataset.filterId || '';
      if (!filterId) {
        control.hidden = false;
        return;
      }

      const matchValue = control.dataset.filterMatch || '';
      const excludeValue = control.dataset.filterExclude || '';
      const hasProducts = items.some((item) => this.itemMatches(item, matchValue, excludeValue));
      control.hidden = !hasProducts;
      control.setAttribute('aria-hidden', hasProducts ? 'false' : 'true');
      if (!hasProducts) {
        control.classList.remove('is-active');
        if (control.hasAttribute('aria-pressed')) {
          control.setAttribute('aria-pressed', 'false');
        }
      }
    });

    this.dropdowns.forEach((dropdown) => {
      const menuItems = [...dropdown.querySelectorAll('[data-filter-menu] [data-filter-id]')];
      const visibleItems = menuItems.filter((item) => !item.hidden);
      const hasVisible = visibleItems.length > 0;
      dropdown.hidden = !hasVisible;
      dropdown.setAttribute('aria-hidden', hasVisible ? 'false' : 'true');
      if (!hasVisible) {
        dropdown.classList.remove('is-open', 'is-active');
        const trigger = dropdown.querySelector('[data-filter-trigger]');
        const menu = dropdown.querySelector('[data-filter-menu]');
        if (trigger) trigger.setAttribute('aria-expanded', 'false');
        if (menu) menu.hidden = true;
      }
    });
  }

  static bind() {
    if (this.bound) return;
    this.bound = true;

    this.bar.addEventListener('click', (event) => {
      const menuItem = event.target.closest('[data-filter-menu] [data-filter-id]');
      if (menuItem && this.bar.contains(menuItem)) {
        event.preventDefault();
        this.closeDropdowns();
        this.apply(menuItem.dataset.filterId || '', { updateURL: true, push: true });
        return;
      }

      const trigger = event.target.closest('[data-filter-trigger]');
      if (trigger && this.bar.contains(trigger)) {
        event.preventDefault();
        const dropdown = trigger.closest('[data-filter-dropdown]');
        const isOpen = dropdown.classList.contains('is-open');
        this.closeDropdowns();
        if (!isOpen) this.openDropdown(dropdown);
        return;
      }

      const pill = event.target.closest('.badass-collection-nav__pill[data-filter-id]');
      if (pill && this.bar.contains(pill)) {
        this.closeDropdowns();
        this.apply(pill.dataset.filterId || '', { updateURL: true, push: true });
      }
    });

    if (this.sortSelect) {
      this.sortSelect.addEventListener('change', () => {
        this.sortValue = this.sortSelect.value || 'featured';
        this.apply(this.filterId, { updateURL: true, push: true, resetPage: true });
      });
    }

    document.addEventListener('click', (event) => {
      if (!this.bar.contains(event.target) && !event.target.closest('[data-filter-menu]')) {
        this.closeDropdowns();
      }
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') this.closeDropdowns();
    });

    window.addEventListener('resize', () => this.closeDropdowns());
    window.addEventListener('scroll', () => this.closeDropdowns(), { passive: true });
  }

  static openDropdown(dropdown) {
    const trigger = dropdown.querySelector('[data-filter-trigger]');
    const menu = dropdown.querySelector('[data-filter-menu]');
    dropdown.classList.add('is-open');
    if (trigger) trigger.setAttribute('aria-expanded', 'true');
    if (menu) {
      menu.hidden = false;
      menu.style.top = '';
      menu.style.left = '';
    }
  }

  static closeDropdowns() {
    this.dropdowns.forEach((dropdown) => {
      dropdown.classList.remove('is-open');
      const trigger = dropdown.querySelector('[data-filter-trigger]');
      const menu = dropdown.querySelector('[data-filter-menu]');
      if (trigger) trigger.setAttribute('aria-expanded', 'false');
      if (menu) {
        menu.hidden = true;
        menu.style.top = '';
        menu.style.left = '';
      }
    });
  }

  static haystackHas(haystack, term) {
    const value = (term || '').trim().toLowerCase();
    if (!value) return true;
    if (value.includes(' ')) return haystack.includes(value);
    const escaped = value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    return new RegExp(`(?:^|[^a-z0-9])${escaped}(?:s)?(?:$|[^a-z0-9])`, 'i').test(haystack);
  }

  static itemMatches(item, matchValue, excludeValue) {
    const haystack = (item.getAttribute('data-filter-tags') || '').toLowerCase();
    const excludes = (excludeValue || '')
      .split(',')
      .map((value) => value.trim().toLowerCase())
      .filter(Boolean);
    if (excludes.some((value) => this.haystackHas(haystack, value))) return false;

    const matches = (matchValue || '')
      .split(',')
      .map((value) => value.trim().toLowerCase())
      .filter(Boolean);
    if (!matches.length) return true;
    return matches.some((value) => this.haystackHas(haystack, value));
  }

  static findControl(filterId) {
    return (
      this.filterControls.find(
        (control) => (control.dataset.filterId || '') === filterId && !control.hidden
      ) ||
      this.filterControls.find((control) => control.dataset.filterId === '') ||
      null
    );
  }

  static sortItems(items) {
    const mode = this.sortValue || 'featured';
    return items.sort((a, b) => {
      const indexA = Number(a.dataset.gridIndex) || 0;
      const indexB = Number(b.dataset.gridIndex) || 0;
      if (mode === 'price-asc' || mode === 'price-desc') {
        const priceA = Number(a.dataset.price) || 0;
        const priceB = Number(b.dataset.price) || 0;
        if (priceA !== priceB) return mode === 'price-asc' ? priceA - priceB : priceB - priceA;
        return indexA - indexB;
      }
      if (mode === 'newest') {
        const publishedA = Number(a.dataset.published) || 0;
        const publishedB = Number(b.dataset.published) || 0;
        if (publishedA !== publishedB) return publishedB - publishedA;
        return indexA - indexB;
      }
      if (mode === 'best-selling') {
        const scoreA = Number(a.dataset.bestseller) || 0;
        const scoreB = Number(b.dataset.bestseller) || 0;
        if (scoreA !== scoreB) return scoreB - scoreA;
        return indexA - indexB;
      }
      return indexA - indexB;
    });
  }

  static apply(filterId, options = {}) {
    if (!this.grid) return;

    const control = this.findControl(filterId);
    this.filterId = control ? control.dataset.filterId || '' : '';
    const matchValue = control ? control.dataset.filterMatch || '' : '';
    const excludeValue = control ? control.dataset.filterExclude || '' : '';

    this.filterControls.forEach((item) => {
      item.classList.toggle('is-active', item === control);
    });

    this.dropdowns.forEach((dropdown) => {
      const groupActive = [...dropdown.querySelectorAll('[data-filter-id]')].some(
        (item) => item.dataset.filterId === this.filterId && this.filterId !== ''
      );
      dropdown.classList.toggle('is-active', groupActive);
    });

    this.bar.querySelectorAll('.badass-collection-nav__pill[data-filter-id]').forEach((pill) => {
      const pressed = (pill.dataset.filterId || '') === this.filterId;
      pill.setAttribute('aria-pressed', pressed ? 'true' : 'false');
    });

    const items = [...this.grid.querySelectorAll('.badass-collection-grid__item')];
    let visibleCount = 0;
    items.forEach((item) => {
      const matches = this.itemMatches(item, matchValue, excludeValue);
      item.classList.toggle('is-filter-hidden', !matches);
      if (matches) visibleCount += 1;
    });

    this.sortItems(items).forEach((item) => this.grid.appendChild(item));

    if (this.empty) this.empty.hidden = visibleCount > 0;

    if (options.updateURL) {
      const params = new URLSearchParams(window.location.search);
      params.delete('page');
      if (options.resetPage !== false) params.delete('gp');
      if (this.filterId) params.set('cf', this.filterId);
      else params.delete('cf');
      if (this.sortValue && this.sortValue !== 'featured') params.set('cs', this.sortValue);
      else params.delete('cs');
      const next = params.toString();
      const url = `${window.location.pathname}${next ? `?${next}` : ''}`;
      const method = options.push ? 'pushState' : 'replaceState';
      history[method]({ searchParams: next }, '', url);
      FacetFiltersForm.searchParamsPrev = next;
    }

    if (options.paginate !== false) {
      CollectionGridPagination.init({ page: options.resetPage === false ? undefined : 1, updateURL: true, push: false });
    }
  }
}

CollectionQuickFilters.init();
CollectionGridPagination.init({ updateURL: false });

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('input').forEach((element) => {
      element.addEventListener('change', this.onRangeChange.bind(this));
      element.addEventListener('keydown', this.onKeyDown.bind(this));
    });
    this.setMinAndMaxValues();
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  onKeyDown(event) {
    if (event.metaKey) return;

    const pattern = /[0-9]|\.|,|'| |Tab|Backspace|Enter|ArrowUp|ArrowDown|ArrowLeft|ArrowRight|Delete|Escape/;
    if (!event.key.match(pattern)) event.preventDefault();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll('input');
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute('data-max', maxInput.value);
    if (minInput.value) maxInput.setAttribute('data-min', minInput.value);
    if (minInput.value === '') maxInput.setAttribute('data-min', 0);
    if (maxInput.value === '') maxInput.setAttribute('data-max', maxInput.getAttribute('data-max'));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute('data-min'));
    const max = Number(input.getAttribute('data-max'));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }
}

customElements.define('price-range', PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector('a');
    facetLink.setAttribute('role', 'button');
    facetLink.addEventListener('click', this.closeFilter.bind(this));
    facetLink.addEventListener('keyup', (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
    });
  }

  closeFilter(event) {
    event.preventDefault();
    const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
    form.onActiveFilterClick(event);
  }
}

customElements.define('facet-remove', FacetRemove);
